import { OptumNoPIIApi } from './optum';
import { ReferralUtilityApi } from './referral-utility';

export const internalApi = {
  optumNoPIIApi: new OptumNoPIIApi(),
  referralUtilityApi: new ReferralUtilityApi(),
};
